import moment from 'moment/moment';
import { makeCapacities } from 'reactApp';

export default function (app) {
  app.controller('klCustomerCenterRatePlanCtrl', [
    '$state',
    '$timeout',
    'klAccountService',
    'klConfigService',
    function ($state, $timeout, AccountService, ConfigService) {
      this.isLoading = true;
      this._config = null;

      this.decreaseQuantity = function () {
        if (!this.canDecreaseQuantity) {
          return;
        }
        this.setDisplayedQuantity(this.displayedQuantity - 1);
      };

      this.increaseQuantity = function () {
        if (!this.canIncreaseQuantity) {
          return;
        }
        this.setDisplayedQuantity(this.displayedQuantity + 1);
      };

      this.amend = function () {
        $state.go('subscription.amend', { ratePlanCtrl: this });
      };

      this.cancel = function () {
        if (this.isResellerSubscription) {
          return $state.go('subscription.cancelReseller', {
            subscriptionId: this.subscription.id,
            subscriptionNumber: this.subscription.subscriptionNumber,
            licenseType: this.ratePlan.ratePlanName,
            endDate: this.subscription.termEndDate,
          });
        }

        if (this.ratePlanCapacities.canCancelEnterpriseCharges()) {
          const account = AccountService.getAccount();
          return $state.go('subscription.cancelEnterprise', {
            enterpriseData: {
              subscriptionId: this.subscription.id,
              email: account.billToContact.workEmail,
              companyName: account.name,
              fullName: `${account.billToContact.firstName} ${account.billToContact.lastName}`,
            },
          });
        }
        $state.go('subscription.cancel', {
          subscriptionId: this.subscription.id,
          subscription: this.subscription,
          ratePlan: this.ratePlan,
        });
      };

      this.uncancel = () => {
        $state.go('subscription.uncancel', {
          subscriptionNumber: this.subscription.subscriptionNumber,
        });
      };

      this.setDisplayedQuantity = function (displayedQuantity) {
        this.displayedQuantity = displayedQuantity;
        this.displayedQuantityIsDefault = displayedQuantity === this.ratePlan.quantity;
        this.displayedQuantityIsHigh = displayedQuantity > this.ratePlan.quantity;
        this.displayedQuantityIsLow = displayedQuantity < this.ratePlan.quantity;

        const amendments = this.ratePlanCapacities.amendments(this.subscription);

        this.canDecreaseQuantity = amendments.canDecreaseSeats(displayedQuantity);

        this.canIncreaseQuantity =
          amendments.canIncreaseSeats(displayedQuantity) &&
          !this.isForeignAccount &&
          !this.isResellerSubscription;

        this.canUpdateQuantity = amendments.canShowUpdateSeatButton(displayedQuantity);
      };

      this.init = function (accountId, subscription, ratePlan) {
        this.accountId = accountId;
        this.subscription = subscription;
        this.ratePlan = ratePlan;
        this.ratePlanCapacities = makeCapacities(this._config).ratePlan(this.ratePlan);
        this.isResellerSubscription = !(
          this.subscription.invoiceOwnerAccountId == AccountService.getAccount().id
        );
        this.isResoldSubscription = !(
          this.subscription.accountId == AccountService.getAccount().id
        );
        this.subscription.messages = this.subscription.messages || [];
        this.canCancelEnterpriseCharges = this.ratePlanCapacities.canCancelEnterpriseCharges();
        this.enterpriseLicenseSeats = 0;
        this.ratePlan.ratePlanCharges.forEach((charge) => {
          if (parseInt(charge.EnterpriseLicenseSeats__c) > 0) {
            this.enterpriseLicenseSeats += parseInt(charge.EnterpriseLicenseSeats__c);
          }
        });
        if (this.isResoldSubscription) {
          this.subscription.messages = this.subscription.messages || [];
          this.subscription.messages.unshift({ type: 'isResold' });
        }
        if (!!this.subscription.messages && this.subscription.messages.length > 1) {
          let cancelmsg = null;
          this.subscription.messages.forEach(function (msg) {
            if (msg.type === 'cancel') {
              cancelmsg = msg;
            }
          });
          if (cancelmsg) {
            this.subscription.messages = [cancelmsg];
          }
        }
      };

      this.update = function () {
        this.canCancel = this.subscriptionCapacities.canBeCancelled();
        this.canUncancel = this.subscriptionCapacities.canBeUncancelled();
        this.isForeignAccount = AccountService.getAccount().id != this.accountId;
        this.isResellerSubscription =
          this.subscription.invoiceOwnerAccountId != AccountService.getAccount().id;
        this.setDisplayedQuantity(this.ratePlan.quantity);
        if (this.isResellerSubscription) {
          this.subscription.messages.push({ type: 'fromReseller' });
        }
      };

      ConfigService.getConfig().then((config) => {
        this._config = config;
        const capacities = makeCapacities(this._config);
        this.ratePlanCapacities = capacities.ratePlan(this.ratePlan);
        this.subscriptionCapacities = capacities.subscription(this.subscription);
        this.update();
        this.isLoading = false;
      });
    },
  ]);
}
